
import { Options, Vue } from 'vue-class-component';
import { getData as getFueros } from '@/api/FuerosApi';
import { getPeritos, downloadPdf } from '@/api/PeritosApi';
import Fuero from '@/model/Fuero';
import Perito from '@/model/Perito';
import { notifyError } from '@/utils/NotifyUtils';

@Options({
  components: {},
  name: 'PadronInscripciones',
  watch: {
    model: 'loadPeritos',
  },
})
export default class PadronInscripciones extends Vue {
  options: Fuero[] = [];
  model: number | null = null;
  links: Perito[] = [];
  loadingFueros = false;
  loadingPeritos = false;
  peritosRequest = 0;
  downloadingId: number | null = null;

  async download(id: number) {
    this.downloadingId = id;
    try {
      await downloadPdf(id);
    } catch (err) {
      notifyError(err.message ? err.message : err);
    } finally {
      this.downloadingId = null;
    }
  }

  async mounted() {
    this.loadingFueros = true;
    try {
      this.options = (await getFueros()) || [];
      this.model = this.options.find((fuero) => fuero.id === 0)?.id ?? this.options[0]?.id ?? null;
    } catch (err) {
      notifyError('No se pudieron cargar las jurisdicciones.');
    } finally {
      this.loadingFueros = false;
    }
  }

  async loadPeritos() {
    const request = ++this.peritosRequest;
    this.links = [];
    this.loadingPeritos = false;
    if (this.model === null) return;

    this.loadingPeritos = true;
    try {
      const peritos = await getPeritos(this.model);
      if (request === this.peritosRequest) {
        this.links = peritos.sort((a, b) => a.descripcion.localeCompare(b.descripcion, 'es', { sensitivity: 'base' }));
      }
    } catch (err) {
      if (request === this.peritosRequest) {
        notifyError('No se pudo cargar el padrón de la jurisdicción seleccionada.');
      }
    } finally {
      if (request === this.peritosRequest) this.loadingPeritos = false;
    }
  }
}
